export default __webpack_public_path__ + "static/media/girl.6d6be798.png";